export const MESSAGE = {
  network_error:
    "Feature Unavailable Offline. Check your internet connection and try again.",
  loading: "Loading Plugin...",
  provideItemId: "Please provide a valid itemId",
  mobile_error:
    "This journal activity cannot be accessed on the mobile app. You can view it by logging into our web app instead",
  waitingForFit: "Waiting for FIT Initialization...",
  sessionUnavailable: "Journal session is not available. Please sign in and try again.",
  loadingWritingSolution: "Loading Writing Solution...",
} as const;

export const MODE_QUESTION_ONLY = "question_only";
export const TOOL_CONSUMER_BRONTE = "BRONTE";
